import type { IModel } from '@/apiClient/types/model'

/**
 * Adding default model values for Cotex/guide to preserve the UI element "generated by {modelName}"
 * This is needed since Cortex/guide models will be deprecated
 */
export const defaultModels: IModel[] = [
  {
    slug: '@lf/qwen/cortex',
    foundry_id:
      '977088c9fb7d57994187cd5691f8aa370c5926105bd2c60bd85764482833c266',
    object: 'model',
    created_at: '2025-07-23T18:41:28.231745Z',
    updated_at: '2025-09-05T17:41:14.311386Z',
    max_model_length: 32768,
    max_output_tokens: null,
    max_audio_size: null,
    display_name: 'Cortex (Generalist)',
    description: 'Best for balanced responses and short-to-medium documents.',
    description_long:
      'Large-scale reasoning model with solid general knowledge. Ideal for broad tasks that don’t require ultra-long context.',
    provider: 'kubeai',
    features: {
      instruct: true,
      vision: true,
    },
    name: '@lf/qwen/cortex',
    owned_by: 'openai',
    openai: {
      slug: '@lf/qwen/cortex',
      foundry_id:
        '977088c9fb7d57994187cd5691f8aa370c5926105bd2c60bd85764482833c266',
      object: 'model',
      created_at: '2025-07-23T18:41:28.231745Z',
      updated_at: '2025-09-05T17:41:14.311386Z',
      max_model_length: 32768,
      max_output_tokens: null,
      max_audio_size: null,
      display_name: 'Cortex (Generalist)',
      description: 'Best for balanced responses and short-to-medium documents.',
      description_long:
        'Large-scale reasoning model with solid general knowledge. Ideal for broad tasks that don’t require ultra-long context.',
      provider: 'kubeai',
      features: {
        instruct: true,
        vision: true,
      },
    },
    urlIdx: 0,
  },
  {
    slug: '@lf/qwen/cortex-large',
    foundry_id:
      'd9bd102dc435368b89bfb9e4011196c45fe48ba1f6673dcbe47b391e34fd12b2',
    object: 'model',
    created_at: '2025-09-29T23:37:52.226665Z',
    updated_at: '2025-09-29T23:37:52.226677Z',
    max_model_length: 500000,
    max_output_tokens: 8192,
    max_audio_size: null,
    display_name: 'Guide',
    description: null,
    description_long: null,
    provider: 'kubeai',
    features: {
      instruct: true,
      vision: true,
    },
    name: '@lf/qwen/cortex-large',
    owned_by: 'openai',
    openai: {
      slug: '@lf/qwen/cortex-large',
      foundry_id:
        'd9bd102dc435368b89bfb9e4011196c45fe48ba1f6673dcbe47b391e34fd12b2',
      object: 'model',
      created_at: '2025-09-29T23:37:52.226665Z',
      updated_at: '2025-09-29T23:37:52.226677Z',
      max_model_length: 500000,
      max_output_tokens: 8192,
      max_audio_size: null,
      display_name: 'Guide',
      description: null,
      description_long: null,
      provider: 'kubeai',
      features: {
        instruct: true,
        vision: true,
      },
    },
    urlIdx: 0,
  },
  {
    slug: '@lf/llama/guide',
    foundry_id:
      '86ff9dc866b54ef2a9f843a8d6f8d333f2a6b9cbfb7f09a260ed69bbd4e40a26',
    object: 'model',
    created_at: '2025-07-23T18:41:28.259085Z',
    updated_at: '2025-09-05T17:42:02.160187Z',
    max_model_length: 65536,
    max_output_tokens: null,
    max_audio_size: null,
    display_name: 'Guide (Step-by-step)',
    description: 'Ideal for instructions, how-tos, and structured guidance.',
    description_long:
      'Finely tuned for clear, sequential responses. Great for FAQs, SOPs, and support flows.',
    provider: 'kubeai',
    features: {
      instruct: true,
    },
    name: '@lf/llama/guide',
    owned_by: 'openai',
    openai: {
      slug: '@lf/llama/guide',
      foundry_id:
        '86ff9dc866b54ef2a9f843a8d6f8d333f2a6b9cbfb7f09a260ed69bbd4e40a26',
      object: 'model',
      created_at: '2025-07-23T18:41:28.259085Z',
      updated_at: '2025-09-05T17:42:02.160187Z',
      max_model_length: 65536,
      max_output_tokens: null,
      max_audio_size: null,
      display_name: 'Guide (Step-by-step)',
      description: 'Ideal for instructions, how-tos, and structured guidance.',
      description_long:
        'Finely tuned for clear, sequential responses. Great for FAQs, SOPs, and support flows.',
      provider: 'kubeai',
      features: {
        instruct: true,
      },
    },
    urlIdx: 0,
  },
]
